import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 *
 * @param title
 * @param items
 * @param pullRight
 * @param onSelect
 * @description Submenu сделано через CSS (hover)
 * @returns {JSX.Element}
 * @constructor
 */
const DropdownSubMenu = ({ title, items, pullRight, onSelect }) => {
  const onClickItem = (e, item) => {
    e.preventDefault();
    onSelect(e, item);
  };

  return (
    <li className="dropdown dropdown-submenu">
      <a href="/#" className="dropdown_menu dropdown-submenu__title" onClick={(e) => e.preventDefault()}>
        {title}
      </a>
      <ul
        className={classNames('dropdown-menu submenu-drop', {
          'submenu-drop__right': pullRight,
          'submenu-drop__left': !pullRight,
        })}
      >
        {items.map((item, index) => (
          <li key={index}>
            <a href="# " onClick={(e) => onClickItem(e, item)}>
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
};

DropdownSubMenu.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  pullRight: PropTypes.bool,
};

DropdownSubMenu.defaultProps = {
  pullRight: true,
};

export default DropdownSubMenu;
